import { Box } from '@mui/material';
import React from 'react';
import { INVENTORY_BASE_URL } from 'views/Inventory/constants';
import LearnMore from './LearnMore';

const InventoryLearnMore = () => {
	return (
		<Box mt={7} mb={3}>
			<LearnMore linkHref={INVENTORY_BASE_URL} labelVariant="inventory" />
		</Box>
	);
};

export default InventoryLearnMore;
